import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Checkbox from '../Checkbox';

export default () => (
  <>
    <Heading level={1}>Disabled State</Heading>
    <Spacer size={16} />
    <Text>
      The disabled state of the <Code>Checkbox</Code> component is controlled
      via the <Code>disabled</Code> prop.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} disabled={false} />
        <Spacer size={6} />
        <Code>{'disabled={false}'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} disabled={true} />
        <Spacer size={6} />
        <Code>{'disabled={true}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
